module.exports = __webpack_public_path__ + "static/media/qwanticWhite.cead6138.svg";